@if (isLoading) {
  <div class='loading-spinner' style="position:fixed; z-index: 9;"></div>
}
<div class="top-title-main" [style]="{'opacity': (isLoading ? 0.3 : 1)}">
  <div class="divider">
    <div class="pageTitle" style="float: left">Accounts</div>
  </div>
  <div class="top-action-btn-content">
    <button (click)="createRebalance()" [disabled]="disableActionBtn" class="btn-large-primary rebalanceDisable relative">Rebalance
      @if (disableActionBtn) {
        <div style="position:absolute;left:0;top:0;z-index: 9999; width: 104px; height: 32px" tooltip [tooltipPosition]="'right'" [tooltipTitle]="'Rebalance the items selected below'"></div>
      }
    </button>
    <button style="position: relative;"  [matMenuTriggerFor]="subMenu2" class="btn-large-secondary btnWithArrow"
      >Import<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
      <mat-menu #subMenu2="matMenu" class="nav__items_action_btn" yPosition="below">
        <button class="nav__item_action_btn" mat-menu-item (click)="showImportCashSettingsDialog()">Cash Settings</button>
      </mat-menu>
    </button>
    <button style="position: relative;"  [matMenuTriggerFor]="subMenu1" [disabled]="disableActionBtn" class="btn-large-secondary btnWithArrow"
      >Actions<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>@if (disableActionBtn) {
      <div style="position:absolute;left:0;top:0;z-index: 9999; width: 104px; height: 32px" tooltip [tooltipPosition]="'right'" [tooltipTitle]="'Activate &quot;Actions&quot; by first selecting the checkboxes for the accounts below'"></div>
    }</button>
    @if (this.dataTransferService.ShowExternalAccounts) {
      <button style="position: relative;" [matMenuTriggerFor]="subMenu3" class="btn-large-secondary btnWithArrow"
        >External Accounts<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
        <mat-menu #subMenu3="matMenu" class="nav__items_action_btn" yPosition="below">
          <button class="nav__item_action_btn" mat-menu-item (click)="showCreateExternalDialog()">Create</button>
          <button class="nav__item_action_btn" mat-menu-item (click)="showImportExternalDialog()">Import</button>
          <button class="nav__item_action_btn" [disabled]="disableDeleteExternalAccountBtn" (click)="showDeleteExternalAccountsDialog()" mat-menu-item>Delete</button>
        </mat-menu>
      </button>
    }
    <button style="position: relative;" [matMenuTriggerFor]="subMenuSAC" class="btn-large-secondary btnWithArrow"
      >Go to SAC<i class="material-icons md-24 md-align dropdown-arrow-align" >arrow_drop_down</i>
      <mat-menu #subMenuSAC="matMenu" class="nav__items_action_btn" yPosition="below">
        <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_BAL','_blank')">Balances</button>
        <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_POS','_blank')">Positions</button>
        <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_TRAN','_blank')">Transactions</button>
        <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_COST','_blank')">Cost Basis</button>
        <button class="nav__item_action_btn external" mat-menu-item (click)="window.open(redirectURL + '/?sanc=A_RMD','_blank')">RMD</button>
      </mat-menu>
    </button>
  </div>
</div>
<irb-filter-chips [filterData]="_filterChipModel" [dataMap]="filterDisplayNamesData" (removeFilterItem)="onRemoveFilterItem($event)" [context]="loadingOverlayComponentParams"></irb-filter-chips>
@if (!isUiTest) {
  <irb-inventory-grid class="show-grid-toolbar-buttons"
    [style.minHeight]="'600px'"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [loadingOverlayComponent]="'customLoadingOverlay'"
    [loadingOverlayComponentParams]="loadingOverlayComponentParams"
    [componentName]="componentName"
    [footerContent] = "footerContent"
    id ="assigned-accounts-grid"
    [contextMenuItems]="getContextMenuItems()"
    [noRowsOverlayComponent]="'customNoRowOverlay'"
    [noRowsOverlayComponentParams]="loadingOverlayComponentParams"
    [showFiltersColumns]="true"
    [columnLimits]="columnLimits"
  ></irb-inventory-grid>
}
@if (ges.getExportOptions().isGridRequired) {
  <irb-ag-grid-export (callbackMethod)="ges.resetExportGrid($event)" [exportOptions]="ges.getExportOptions()" [rowData]="ges.getExportOptions().gridOptions.rowData" [isGridRequired]="ges.getExportOptions().isGridRequired" [exportType]="'csv'"></irb-ag-grid-export>
}

<mat-menu #subMenu1="matMenu" class="nav__items_action_btn" yPosition="below">
  <button class="nav__item_action_btn" (click)="showEditMultipleAccountsDialog()" mat-menu-item>Edit</button>
  <button class="nav__item_action_btn" mat-menu-item [matMenuTriggerFor]="export">Export</button>
</mat-menu>

<mat-menu #export="matMenu" class="nav__items_action_btn isSubMenu">
  <button class="nav__item_action_btn" mat-menu-item (click)="exportAccountDetails()">Account Details</button>
  <button class="nav__item_action_btn" mat-menu-item (click)="exportAccountCashSettings()">Account Cash Settings</button>
  <button class="nav__item_action_btn" mat-menu-item (click)="exportExternalAccountHoldings()">External Holdings</button>
</mat-menu>

<ng-template #accountNumberOverlay>
  @if (row) {
    <div>
      <div class="hblock" style="color: #999; font-size: 11px;">Export</div>
      <div style="padding-left: 10px">
        <div class="hblock clickable" (click)="exportAccountDetails(row.accountNumber); closeMenu();">Account Details</div>
        <div class="hblock clickable" (click)="exportAccountCashSettings(row.accountNumber); closeMenu();">Account Cash Settings</div>
        <div class="clickable" (click)="exportExternalAccountHoldings(row.accountId); closeMenu();">External Holdings</div>
      </div>
      @if (!row.isExternalAccount) {
        <hr style="margin: 8px 0; border: none; border-top: 1px solid #e0e0e0;">
        <div class="hblock" style="color: #999; font-size: 11px;">Go to SAC</div>
        <div style="padding-left: 10px">
          @for (item of sacMenuItems; track item) {
            <div class="hblock clickable" (click)="openSACWithContext(item.sanc); closeMenu(); $event.stopPropagation();">
              {{item.label}} <i class="material-icons" style="font-size: 16px; color: #666; float: right;">open_in_new</i>
            </div>
          }
        </div>
      }
    </div>
  }
</ng-template>
